import React from 'react'
import Box from '@mui/material/Box'
import BottomNavigation from '@mui/material/BottomNavigation'
import BottomNavigationAction from '@mui/material/BottomNavigationAction'
import ChatBubbleIcon from '@mui/icons-material/ChatBubble'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import { InnerHeight, Roles, STATUSES_CHAT_SALES } from '../../utils/consts'
import { useSelector } from 'react-redux'
import { EMainView, IStore } from '../../store/types'
import { setMainView } from '../../store/mainViewSlice'
import { AllChats } from '../AllChats'
import { Settings } from '../Settings'
import { Search } from '../Search'
import { ListGroupTemplates } from '../Templates/ListGroupTemplates'
import { useLocation, useNavigate } from 'react-router-dom'
import { ROUTES } from '../../utils/routes'
import { ChatsSalesActions } from '../../store/chatsSales'
import { searchChats } from '../../store/searchChatsSales/actions'
import { ISearchChat } from '../../store/searchChatsOnline/types'
import { useAppDispatch } from '../../store'
import { TemplatesSalesActions } from '../../store/templatesSales'
import { IGroupTemplate } from '../../store/templates/types'
import { SearchChatsSalesActions } from '../../store/searchChatsSales'
import { IProduct } from '../../store/products/types'
import { ChatItemSales } from '../ChatItem'
import { getChats, getChatsByPage } from '../../store/chatsSales/actions'
import { useScrollChats } from '../../hooks/useScrollChats'

export const MainWorkspaceSales: React.FC<{ children: any }> = ({ children }) => {
  const [statuses, setStatuses] = React.useState<{ value: string | number; label: string }[]>([])
  const [subProducts, setSubProducts] = React.useState<IProduct[]>([])
  const { chatsSales, mainView, templatesSales, users, configurations } = useSelector((store: IStore) => store)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const { handleScroll } = useScrollChats({
    data: chatsSales,
    getChats: getChatsByPage,
  })

  const checkActiveBtn = () => {
    if (location.pathname.includes(ROUTES.templatesSales)) return dispatch(setMainView(EMainView.textSettings))
    if (location.pathname.includes(ROUTES.settingsSales)) return dispatch(setMainView(EMainView.settings))
    if (location.pathname.includes(ROUTES.searchSales)) return dispatch(setMainView(EMainView.search))
    dispatch(setMainView(EMainView.chat))
  }

  React.useEffect(() => {
    checkActiveBtn()
    const data = Object.entries(STATUSES_CHAT_SALES).map((item) => ({ value: Number(item[0]), label: item[1].title }))
    setStatuses([{ value: 0, label: 'Усі' }, ...data])
  }, [])

  React.useEffect(() => {
    if (configurations.products) {
      const subProducts = [] as IProduct[]
      configurations.products.map((it) => {
        if (it.children) {
          subProducts.push(...it.children)
        }
      })
      setSubProducts(subProducts)
    }
  }, [configurations])

  React.useEffect(() => {
    if (mainView === EMainView.chat && users.socket) {
      dispatch(getChats({ status: chatsSales.statusChat }))
    }
  }, [chatsSales.statusChat, mainView, users.socket])

  const handleSearch = (values: ISearchChat, callback?: (success?: boolean) => void) => {
    dispatch(SearchChatsSalesActions.setSearchFields(values))
    dispatch(searchChats(values)).then(() => callback && callback())
  }

  const handleSetGroup = (group: IGroupTemplate) => {
    dispatch(TemplatesSalesActions.setCurrentGroup(group))
  }

  const handleChangeStatus = (status: number) => {
    dispatch(ChatsSalesActions.changeStatus(status))
    navigate(ROUTES.routeChange(''))
  }

  const renderWorkspaceLeft = () => {
    switch (mainView) {
      case EMainView.chat:
        return (
          <AllChats
            statuses={statuses}
            total={chatsSales.chats?.total || 0}
            status={chatsSales.statusChat}
            handleChange={handleChangeStatus}
            handleScroll={handleScroll}
          >
            <>
              {chatsSales.chats?.chats.map((item, idx) => (
                <ChatItemSales key={`1_${idx}`} chat={item} />
              ))}
            </>
          </AllChats>
        )
      case EMainView.textSettings:
        if (users.user?.role === Roles.ADMIN || users.user?.role === Roles.CHIEF) {
          return <ListGroupTemplates groups={templatesSales.groups} setCurrentGroup={handleSetGroup} />
        }
        return <Box />
      case EMainView.settings:
        return <Settings />
      case EMainView.search:
        return (
          <Search
            statuses={Object.keys(STATUSES_CHAT_SALES).map((key) => ({
              value: key,
              label: STATUSES_CHAT_SALES[key].title,
            }))}
            types={[
              { value: '1', label: 'Онлайн' },
              { value: '2', label: 'Офлайн' },
              { value: '3', label: 'Пропущений' },
            ]}
            products={subProducts}
            searchChats={handleSearch}
          />
        )
      default:
        return <Box />
    }
  }

  const handlerChange = (num: number) => {
    if (num === 0) {
      navigate(ROUTES.routeChange(''))
    }
    dispatch(setMainView(num))
    switch (num) {
      case EMainView.chat:
        return navigate(ROUTES.chatsSales)
      case EMainView.textSettings:
        return navigate(ROUTES.templatesSales)
      case EMainView.settings:
        return navigate(ROUTES.settingsSales)
      case EMainView.search:
        return navigate(ROUTES.searchSales)
      default:
        return <Box />
    }
  }

  if (!users.user?.approved_online) return null

  return (
    <React.Fragment>
      <Box display={'flex'}>
        <Box>
          <Box
            sx={{ width: '25vw', maxWidth: 500, minWidth: 300, height: InnerHeight, background: 'white' }}
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'space-between'}
            boxShadow={'4px 2px 5px rgba(0,0,0,0.1)'}
          >
            {renderWorkspaceLeft()}
            <BottomNavigation
              showLabels
              value={mainView}
              sx={{ borderTop: '1px solid #dcdcdc', background: '#f5f5f5' }}
              onChange={(e, num) => handlerChange(num)}
            >
              <BottomNavigationAction label='' icon={<ChatBubbleIcon />} />
              {users.user?.role === Roles.ADMIN || users.user?.role === Roles.CHIEF ? (
                <BottomNavigationAction label='' icon={<DescriptionOutlinedIcon />} />
              ) : null}
              <BottomNavigationAction label='' icon={<SettingsOutlinedIcon />} />
              <BottomNavigationAction label='' icon={<SearchOutlinedIcon />} />
            </BottomNavigation>
          </Box>
        </Box>
        <Box
          flex={1}
          display={'flex'}
          justifyContent={'center'}
          alignItems={chatsSales.currentChat ? 'start' : 'center'}
          maxHeight={InnerHeight}
        >
          <Box display={'flex'} flexDirection={'column'} flex={1} height={InnerHeight} position={'relative'}>
            {children}
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  )
}
